import { getRowValue } from '@/app/modules/export/getRowValue';
import { type ExportConfig } from '../modules/export/types';

/**
 * Builds the CSV text (header + rows) for an export config. Pure and DOM-free so
 * it can be unit-tested and reused; the download side effect lives in exportToCSV.
 */
export function buildCsvContent(config: Pick<ExportConfig, 'columns' | 'rows'>): string {
  const { columns, rows } = config;

  const escapeCsvValue = (value: string): string => {
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const headerRow = columns.map((col) => escapeCsvValue(col.header)).join(',');

  const dataRows = rows.map((row) =>
    columns
      .map((col) => {
        const value = getRowValue(row, col.key);
        if (col.format) {
          return escapeCsvValue(String(col.format(row) ?? ''));
        }
        return escapeCsvValue(value !== undefined && value !== null ? String(value) : '');
      })
      .join(','),
  );

  return [headerRow, ...dataRows].join('\n');
}

export function exportToCSV(config: ExportConfig) {
  const { filename = 'table.csv' } = config;

  const csvContent = buildCsvContent(config);
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
